import { useTranslation } from 'react-i18next';
import { EauStatusesEnum } from '@thinknet-gmbh/platform-common';
import {
  EMPTY_ILLUSTRATIONS,
  EmptyContainer,
  Table,
  Tag,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';


import { dateFormat } from 'src/common/helpers/date.helpers';
import EauTableRowActions from './eau-table-row-actions.component';

import { EAU_STATUSES_STYLES } from '../../eau.constants';
import { IEauTableProps } from './eau-table.interfaces';

const EauTable = ({
  dataSource,
  paginationConfig,
  handleModals,
  loading,
}: IEauTableProps) => {
  const { t } = useTranslation(['common', 'applications']);

  return (
    <Table
      loading={loading}
      dataSource={dataSource}
      pagination={paginationConfig}
      rowKey={record => record._id}
      t={t}
      locale={{
        emptyText: (
          <EmptyContainer
            illustration={EMPTY_ILLUSTRATIONS.dataAnalysis}
            emptyTitle={t('common:emptyContainer.emptyTitle')}
          />
        ),
      }}
    >
      <Table.Column
        title={t('applications:eAU.labels.employee')}
        render={({ employee }) => <Typography>{employee?.profile?.displayName}</Typography>}
      />
      <Table.Column
        title={t('applications:eAU.labels.employeeNumber')}
        render={({ employee }) => (
          <Typography>{employee?.employeePersonalInfo?.employeeNumber}</Typography>
        )}
      />

      <Table.Column
        title={t('applications:eAU.labels.time')}
        render={({ firstDay, lastDay }) => {
          return <Typography>{`${dateFormat(firstDay)}-${dateFormat(lastDay)}`}</Typography>;
        }}
      />

      <Table.Column
        title={t('applications:eAU.labels.healthInsurance')}
        render={({ healthInsurance }) => {
          return <Typography>{healthInsurance?.name}</Typography>;
        }}
      />

      <Table.Column
        title={t('applications:eAU.labels.status')}
        render={({ status }) => {
          const { background, fontColor } = EAU_STATUSES_STYLES[
            status ? (status as EauStatusesEnum) : EauStatusesEnum.open
          ];

          return (
            <Tag background={background} fontColor={fontColor}>
              {t(`applications:eAU.statuses.${status?.toLowerCase()}`)}
            </Tag>
          );
        }}
      />
      <Table.Column
        width={50}
        title={t('common:labels.action')}
        render={record => <EauTableRowActions record={record} handleModals={handleModals} t={t} />}
      />
    </Table>
  );
};

export default EauTable;
